// Llave PUBLICA de MercadoPago del restaurante. Ya no vive en el front: la entrega domicompro-api
// desde la tabla `integrations` (fila del restaurante o, si no tiene, la de Precompro). El backend
// cobra con el accessToken de esa misma cuenta: un token hecho con otra llave publica MercadoPago
// lo rechaza. Devuelve null si no hay llave (el componente avisa "pago no disponible").
import { api } from '@/helpers/api';

export default async function llaveMercadoPago (vendorId) {
  if (!vendorId) return null;
  try {
    const { data } = await api.get('marketplace/payment/mercadopago/public-key/' + vendorId);
    return (data && data.data && data.data.publicKey) || null;
  } catch (e) {
    return null;
  }
}
